const config = {
    AUTH_ADDRESS: 'https://auth.dblog.pl/dashboard',
    API_ADDR: 'https://api.dblog.pl',
    MAIN_PAGE_ADDR: 'https://dblog.pl',
    DOMAINS: [
        'dblog.pl'
    ],
    SERVER_IP: '167.99.137.43',
    LANG: 'pl',
    BOTS: ['tipu', 'hivebuzz', 'text2speech', 'poshbot', 'pixresteemer', 'beerlover', 'misterengagement']
}

export default config;
